export default __webpack_public_path__ + "static/media/website-avatar-blank.211f668c.png";